import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { useAsync } from '@sde/widgets-core/src/redux/hooks/useAsync';
import { updateUser, validateUser, getUserDetails } from './actions';
import { VALIDATE_USER, GET_USER_DETAILS } from './constants';

export const userSelector = (state) => state.user;

export const useUser = {
  state: () => {
    const user = useSelect(userSelector);

    return { user };
  },
  actions: () => {
    return {
      updateUser: useAction(updateUser),
      validateUser: useAction(validateUser, {
        saga: useAsync(VALIDATE_USER),
      }),
      getUserDetails: useAction(getUserDetails, {
        saga: useAsync(GET_USER_DETAILS),
      }),
    };
  },
};
